module.exports = __webpack_public_path__ + "assets/3@2x.c5866ee8.png";